// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'category',
    path: '/dashboard/category',
    icon: icon('ic_category'),
  },
  {
    title: 'posts',
    path: '/dashboard/posts',
    icon: icon('ic_posts'),
  },
  {
    title: 'comments',
    path: '/dashboard/comments',
    icon: icon('ic_comments'),
  },
  {
    title: 'subscribers',
    path: '/dashboard/subscribers',
    icon: icon('ic_subscriber'),
  },
  {
    title: 'contacts',
    path: '/dashboard/contacts',
    icon: icon('ic_contacts'),
  },
  {
    title: 'setting',
    path: '/dashboard/setting',
    icon: icon('ic_lock'),
  },

];

export default navConfig;
